import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllAsync, selectConfigControl, selectPaises } from '../../features/pais/paisSlice';
import { isAutoLoadControl } from '../../utils/store/store-utils';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

export default function QCXSelectPaisAutocomplete({
  label,
  name,
  autoLoad,
  initialValues,
  ...restProps
}) {
  const dispatch = useDispatch();
  const list = useSelector(selectPaises);
  const configControl = useSelector(selectConfigControl);

  useEffect(() => {
    if (autoLoad || isAutoLoadControl(configControl)) {
      dispatch(fetchAllAsync());
    }
  }, [configControl]);

  const [defaultValue, setDefaultValue] = useState('');

  useEffect(() => {
    const value = list.find((item) => item?.id === _.get(initialValues, name));
    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue({ id: null, description: '' });
    }
  }, [list, initialValues]);

  const filterOptions = createFilterOptions({
    stringify: (item) => `${item?.description} - ${item?.code?.padStart(3, '0')}`,
  });

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={list}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) => (item?.code && item?.description ? `${item?.description} - ${item?.code?.padStart(3, '0')}` : '')}
      {...restProps}
    />
  );
}
